import type React from "react";

import { AIBadge, AIContainer } from "@similarweb/ai-kit";
import { SWReactIcons } from "@similarweb/icons";
import { FlexColumn } from "@similarweb/ui-components";

import { translate } from "app/filters/i18nFilter";
import { CenteredFlexRow } from "pro-features/styled components/StyledFlex/src/StyledFlex";

import { AIAgentButton } from "./AIAgentButton";
import {
    BannerContainer,
    IconContainer,
    BannerTitle,
    Description,
    BadgeContainer,
    ActionButton,
    AIBadgeWrapper,
} from "./StyledComponents";
import type { IAIAgentBannerProps } from "./types";

export const AIAgentBanner: React.FC<IAIAgentBannerProps> = ({ onActionClick }) => {
    return (
        <BannerContainer>
            <AIContainer borderVariant="soft">
                <CenteredFlexRow>
                    <IconContainer>
                        <SWReactIcons iconName={"seo_assist"} />
                    </IconContainer>
                    <FlexColumn>
                        <BannerTitle>
                            {translate("ai.agent.seo.banner.title")}{" "}
                            <AIBadgeWrapper text={translate("ai.agent.seo.banner.beta")} />
                        </BannerTitle>
                        <Description>{translate("ai.agent.seo.banner.description")}</Description>
                        <BadgeContainer>
                            <AIBadge
                                gradientVariant="softer"
                                text={translate("ai.agent.seo.banner.badge1")}
                            />
                            <AIBadge
                                gradientVariant="softer"
                                text={translate("ai.agent.seo.banner.badge2")}
                            />
                            <AIBadge
                                gradientVariant="softer"
                                text={translate("ai.agent.seo.banner.badge3")}
                            />
                        </BadgeContainer>
                    </FlexColumn>
                </CenteredFlexRow>
                <ActionButton>
                    <AIAgentButton
                        onClick={onActionClick}
                        label={translate("ai.agent.seo.banner.btn.title")}
                    />
                </ActionButton>
            </AIContainer>
        </BannerContainer>
    );
};
